import React from 'react';
import { getContext } from 'common';
import { ListItemBasicContext } from './ListItemBasic';
import Styled from './styles';

interface ListItemActionsProps {
  /** Place content here, consider using <IconButton /> */
  children: React.ReactNode;
}

/** Container component that houses row-actions for the list items.  */
const ListItemActions = React.forwardRef<HTMLElement, ListItemActionsProps>((props: ListItemActionsProps, ref) =>
  getContext(({ RTL }) => {
    const {
      // eslint-disable-next-line react/prop-types
      children,
      ...otherProps
    } = props;
    const { isHovered, isFocused, selected } = React.useContext(ListItemBasicContext);
    return (
      <Styled.ListItemActions
        RTL={RTL}
        ref={ref}
        hide={!isHovered && !isFocused && !selected}
        {...otherProps}
      >
        {children}
      </Styled.ListItemActions>
    );
  }));

ListItemActions.displayName = 'ListItemActions';

export { ListItemActions as default };
